import { createEnvelopeSource } from './create-envelope-source';

/**
 * Technical-health source over the standardized envelope
 * (`GET /analytics/technical-health`, Sentry Release Health for the RPP app).
 * `errorRate` is a ratio rendered as a percent (errored+crashed over total
 * sessions); `failedSessions` is a scalar count (crashed+abnormal). National
 * only: `regionGrain` is `'national'`, so the page's province filter is not
 * forwarded and the card shows the same national figure regardless of region
 * (the "national only" note rides along in the envelope's caveats). Avg session
 * length, the third Technical-health card, stays on the `engagement` source.
 */
export const technicalHealthSource = createEnvelopeSource({
    label: 'Technical health',
    endpoint: 'analytics/technical-health',
    metrics: [
        {
            id: 'errorRate',
            label: 'Error rate',
            type: 'ratio',
            lowerIsBetter: true,
        },
        {
            id: 'failedSessions',
            label: 'Failed sessions',
            type: 'scalar',
            lowerIsBetter: true,
        },
    ],
    forms: ['number', 'rate'],
    regionGrain: 'national',
});
